import clsx from "clsx";
import { runtimeConfig } from "../../lib/config";
import styles from "./InstanceTag.module.css";

/**
 * Which instance you are looking at, stamped in the topbar like the endorsement
 * on a mail bag. A dev build says so in amber — the admin sends real mail, and
 * "am I on production?" should not need a glance at the URL bar.
 */
export function InstanceTag() {
  const isDev = runtimeConfig.version === "dev" || runtimeConfig.version.includes("dirty");

  return (
    <span className={clsx(styles.tag, isDev && styles.dev)} title={`Build ${runtimeConfig.version}`}>
      {runtimeConfig.version}
    </span>
  );
}
